var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.menuList),function(menu,index){return _c('v-list',{key:`${_vm.owner}-menu-group-${index}`,attrs:{"dense":"","nav":""}},[_c('v-subheader',[_vm._v(_vm._s(menu.title))]),_c('MenuItem',{attrs:{"items":menu.items,"owner":`${_vm.owner}-menu-group-${index}`}})],1)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }